import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgBandage = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 45 45", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.55,
      d: "M13.9 42.38a8.16 8.16 0 0 1-11.515 0 8.095 8.095 0 0 1 0-11.475L30.103 3.328a8.16 8.16 0 0 1 11.515 0 8.095 8.095 0 0 1 0 11.476L13.899 42.38Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.65,
      d: "M41.592 30.929a8.095 8.095 0 0 1 0 11.476 8.16 8.16 0 0 1-11.514 0L2.408 14.779a8.094 8.094 0 0 1 0-11.476 8.16 8.16 0 0 1 11.515 0L41.59 30.93h.002Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx("g", { opacity: 0.75, fill: "#65BFF1", children: /* @__PURE__ */ jsx("path", { d: "M31.75 8.905a.795.795 0 1 0 0-1.588.795.795 0 0 0-.797.794c0 .439.357.794.797.794ZM36.797 13.934a.795.795 0 1 0 0-1.588.795.795 0 0 0-.797.794c0 .439.357.794.797.794ZM27.5 13.139a.795.795 0 1 0 0-1.588.795.795 0 0 0-.797.794c0 .438.357.794.797.794ZM32.547 18.17a.795.795 0 1 0 0-1.588.795.795 0 0 0-.797.794c0 .438.357.794.797.794ZM10.921 29.663c.44 0 .797-.356.797-.794a.795.795 0 0 0-.796-.794.795.795 0 0 0-.797.794c0 .438.357.794.796.794ZM15.964 34.692c.44 0 .797-.355.797-.794a.795.795 0 0 0-.796-.794.795.795 0 0 0-.797.794c0 .439.357.794.796.794ZM6.672 33.897a.795.795 0 1 0 0-1.588.795.795 0 0 0-.797.794c0 .438.357.794.797.794ZM11.718 38.926c.44 0 .797-.355.797-.794a.795.795 0 0 0-.797-.794.795.795 0 0 0-.796.794c0 .439.356.794.796.794ZM7.21 13.934c.44 0 .797-.355.797-.794a.795.795 0 0 0-.796-.793.795.795 0 0 0-.797.793c0 .439.357.794.797.794ZM12.258 8.905a.795.795 0 1 0 0-1.588.795.795 0 0 0-.797.794c0 .439.357.794.796.794ZM11.46 18.17c.44 0 .797-.356.797-.794a.795.795 0 0 0-.796-.794.795.795 0 0 0-.797.794c0 .438.357.794.797.794ZM16.508 13.139a.795.795 0 1 0 0-1.588.795.795 0 0 0-.797.794c0 .438.357.794.796.794ZM28.039 34.692a.795.795 0 1 0 0-1.588.795.795 0 0 0-.797.794c0 .438.357.794.797.794ZM33.086 29.663c.44 0 .796-.356.796-.794a.795.795 0 0 0-.796-.794.795.795 0 0 0-.797.794c0 .438.357.794.797.794ZM32.289 38.926a.795.795 0 1 0 0-1.588.795.795 0 0 0-.797.794c0 .438.357.794.797.794ZM37.332 33.897c.44 0 .796-.356.796-.794a.795.795 0 0 0-.796-.794.795.795 0 0 0-.797.794c0 .438.357.794.797.794Z" }) }),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.85,
      d: "m20.973 15.935-5.883 5.863a.215.215 0 0 0 0 .305l7.665 7.64a.217.217 0 0 0 .306 0l5.883-5.864a.215.215 0 0 0 0-.305l-7.665-7.639a.217.217 0 0 0-.306 0Z",
      fill: "#65BFF1"
    }
  )
] });
const ForwardRef = forwardRef(SvgBandage);
export {
  ForwardRef as default
};
